<template>
  <div class="resume-section education-section" :class="{ 'is-compact': compact }">
    <h2 class="section-heading" :style="headingStyle">Education</h2>
    <div v-for="(item, index) in section.data.items" :key="index" class="entry">
      <div class="entry-header">
        <div>
          <h3 class="entry-title">{{ item.degree || 'Degree' }}</h3>
          <p class="entry-org">{{ item.school || 'School Name' }}</p>
          <p v-if="item.description" class="entry-desc">{{ item.description }}</p>
        </div>
        <div class="entry-meta">
          <p>{{ item.startDate || 'Start' }} – {{ item.endDate || 'End' }}</p>
          <p v-if="item.location">{{ item.location }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    section: {
      type: Object,
      required: true
    },
    themeColor: {
      type: String,
      default: '#0f766e'
    },
    compact: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    headingStyle() {
      return {
        color: this.themeColor,
        borderColor: this.themeColor,
      }
    }
  }
}
</script>

<style scoped>
.section-heading {
  font-family: var(--ps-font-display);
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  border-bottom: 2px solid;
  padding-bottom: 0.45rem;
  margin-bottom: 1rem;
}

.entry + .entry {
  margin-top: 0.9rem;
}

.entry-header {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

@media (min-width: 640px) {
  .entry-header {
    flex-direction: row;
    justify-content: space-between;
    gap: 1rem;
  }

  .is-compact .entry-header {
    flex-direction: column;
  }
}

.entry-title {
  font-size: 1rem;
  font-weight: 700;
  color: #0f172a;
}

.entry-org {
  font-size: 0.9rem;
  color: #475569;
  font-weight: 500;
}

.entry-desc {
  margin-top: 0.25rem;
  font-size: 0.875rem;
  color: #64748b;
}

.entry-meta {
  font-size: 0.8rem;
  color: #64748b;
}

@media (min-width: 640px) {
  .entry-meta {
    text-align: right;
    white-space: nowrap;
  }

  .is-compact .entry-meta {
    text-align: left;
  }
}
</style>
